<template>
    <modal-content @close="$emit('close')">
        <project-title-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ProjectTitleForm from '@/modules/ProjectModule/components/Project/Form/ProjectTitleForm';
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';

export default {
    name:       'UpdateProjectTitleDialog',
    components: {ModalContent, ProjectTitleForm},
    computed:   {
        title() {
            return this.$store.getters['projects/project/title'];
        }
    },
    mounted() {
        this.$refs.form.setValues(this.title);
    },
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/project/updateProject', data)
            this.updateProject(data)
                .then(() => {
                    this.$refs.form.reset();
                    this.$emit('close');
                }).catch((message) => this.$notify({text: message, type: 'danger'}));
        }
    }
}
</script>
